module.exports = __webpack_public_path__ + "media/images/common/logo_bg_12-2fdb2e55705d878240c325ec334ee935.png";